import React from 'react';

function InfoCardValue({ children: value, title = value }) {
  return (
    <div className="value" title={typeof title === 'string' ? title : undefined}>
      {value || '-'}
    </div>
  );
}

export default InfoCardValue;
